export const recipts = [ { name: 'Veganer Matcha Shake',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '½ l Mandelmilch',
   '1 reife Banane',
   '2 Datteln',
   '1 TL Chia-Samen',
   '1,5 TL Matcha-Pulver',
   '½ TL Zitronensaft' ],
preparation:
 [ 'Banane schälen und zusammen mit der Mandelmilch, den Datteln, den Chia-Samen und dem Matcha-Pulver in einem hohen Gefäß mixen oder fein pürieren.',
   'Shake in ein Glas schütten. Zitronensaft in den Shake rühren und servieren.' ],
portions: 1,
tags: [ 'Wachmacher', 'Snacks', 'Drink', 'Vegan' ] },
{ name: 'Tomatensuppe vegan',
prev: 'vegan_tomaten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '½ Zwiebel',
   '1 Knoblauchzehe',
   '1 Chilischote',
   '2 Orangen (ungespritzt)',
   '2 EL Olivenöl',
   '2 TL Tomatenmark',
   '1 kl. Dose geschälte Tomaten (150 g)',
   '200 ml gesalzenes Wasser',
   ',Salz, Pfeffer, Kräuter' ],
preparation:
 [ 'Zwiebel und Knoblauch schälen, feinhacken. Chilischote waschen, in feine Ringe schneiden. Orangen schälen und rund 120 ml Saft auspressen. Die Schale einer halben Orange zur Seite legen.',
   'Olivenöl in einer Pfanne erhitzen. Zwiebelwürfel, Knoblauch und Chili in die Pfanne geben, kurz andünsten. Anschließend Tomatenmark dazugeben und kurz mitbraten. Orangensaft und die Schale der halben Orange in die Pfanne geben. Kurz einkochen lassen.',
   'Dosentomaten abtropfen lassen und zusammen mit gesalzenem Wasser in die Pfanne geben. Kurz aufkochen lassen und bei mittlerer Hitze 15-20 Minuten kochen lassen.',
   'Organgenschale aus der Suppe nehmen. Suppe fein pürieren. Mit Salz, Pfeffer und Kräutern abschmecken.' ],
portions: 2,
tags: [ 'Der Klassiker', 'Lunch', 'Vegan' ] },
{ name: 'Scharfe Kokos-Linsen Suppe',
prev: 'scharfe_kokos_linsensuppe_vegan.jpg',
time: '25 min.',
ingredients:
 [ '1 Stück Ingwer (haselnussgroß)',
   '1 Zwiebel',
   '300 ml Kokosmilch',
   '150 ml Wasser',
   '100 g rote Linsen',
   '2 EL Olivenöl',
   '1 Dose Tomatenstücke (200 g)',
   '½ Zitrone',
   ',Salz, Pfeffer, Chilipulver' ],
preparation:
 [ 'Zwiebel und Ingwer schälen, in feine Stücke schneiden. Wasser in einem Wasserkocher zum Kochen bringen.',
   'Olivenöl in einer hohen Pfanne erhitzen. Ingwer, Zwiebel und Linsen dazugeben, kurz andünsten.',
   'Kokosmilch, das aufgekochte Wasser sowie Tomatenstücke in die Pfanne geben. Mit Chilipulver würzen. Kurz aufkochen lassen und rund 10 Minuten köcheln lassen.',
   'Suppe mit Salz, Pfeffer, Zitronensaft abschmecken.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Ingwer Karotten Suppe ',
prev: 'vegane_ingwer_karotten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 Zwiebel',
   '300 g Möhren',
   '100 ml gesalzenes Wasser',
   '1 Stück Ingwer (haselnussgroß)',
   ',¼ Bund Petersilie',
   '2 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Zwiebel und Ingwer schälen, feinwürfeln. Möhren waschen, schälen und in kleine Stücke schneiden.',
   'Olivenöl in einem Topf erhitzen. Zwiebelstückchen kurz anbraten bis sie glasig sind. Anschließend die Möhren- und Ingwer Stücke dazugeben und ebenfalls kurz anbraten. Gemüse mit gesalzenem Wasser ablöschen und bei mittlerer Hitze rund 15 - 20 Minuten köcheln lassen.',
   'Suppe fein pürieren und mit Salz und Pfeffer abschmecken. Petersilie waschen, hacken und über die Suppe streuen.' ],
portions: 2,
tags: [ 'Vitaminbombe', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Spinat Kokos Suppe',
prev: 'vegane_kokos_spinat_suppe.jpg',
time: '25 min.',
ingredients:
 [ '200 ml Kokosmilch',
   '100 g Sellerie',
   '250 ml Wasser',
   '100 g Fenchel',
   '200 g Blattspinat',
   '½ Chilischote',
   '1 Möhre',
   '1 Stück Ingwer (haselnussgroß)',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Wasser und Kokosmilch in einen Topf geben und aufkochen lassen.',
   'Fenchel und Sellerie waschen, schälen und in feine Stücke schneiden. Gemüse in den Topf geben und bei mittlerer Hitze rund 10 Minuten kochen lassen.',
   'Spinat waschen, feinhacken. Möhre waschen, schälen und in feine Streifen schneiden. Ingwer schälen, feinhacken. Chili waschen, in feine Ringe schneiden.',
   'Alle Zutaten in die Suppe geben und bei geringer Hitze 4 Minuten köcheln lassen. Mit Salz und Pfeffer abschmecken.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Kichererbsen-Blumenkohl Salat',
prev: 'kichererbsen_blumenkohlsalat_vegan.jpg',
time: '20 min.',
ingredients:
 [ '1/2 Blumenkohl',
   '1 Dose Kichererbsen (240 g Abtropfgewicht)',
   '2 Stangen Frühlingszwiebeln',
   ',¼ Bund Petersilie',
   '3 EL Olivenöl',
   '½ Zitrone',
   '1 TL Curry',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Blumenkohl waschen, in feine Röschen teilen und klein schneiden. Olivenöl in einer Pfanne erhitzen. Blumenkohl rund 10 Minuten bei mittlerer Hitze anbraten.',
   'Kichererbsen abtropfen lassen, mit Wasser abspülen. Anschließend in eine Schüssel geben und 1 EL Olivenöl dazu geben. Frühlingszwiebeln waschen, in feine Ringe schneiden. Petersilie waschen, feinhacken. Zwiebel und Petersilie mit den Kichererbsen vermengen.',
   'Zitrone auspressen und Zitronensaft ebenfalls in die Schüssel geben. Blumenkohl hinzugeben. Mit Curry, Salz und Pfeffer abschmecken. Vor dem Servieren abkühlen lassen.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Snacks', 'Vegan' ] },
{ name: 'Veganes Thai Curry mit Süßkartoffeln',
prev: 'veganes_thai_curry_suesskartoffeln.png',
time: '30 min.',
ingredients:
 [ '2 große Süßkartoffeln',
   '1 Brokkoli',
   '½ Bund Frühlingszwiebeln',
   '1 rote Paprika',
   '2 Möhren',
   '1 kl. Dose Kokosmilch',
   '1 Limette',
   '1 EL Soja-Soße',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Currypulver' ],
preparation:
 [ 'Kartoffeln waschen, schälen und in kleine Stücke schneiden.',
   'Restliches Gemüse waschen und in kleine Stückchen schneiden. Limette auspressen.',
   'Olivenöl in einer Pfanne erhitzen. Möhrenstücke dazu geben, kurz anbraten. Anschließend nach und nach Brokkoli, Paprika und Frühlingszwiebel dazugeben. Kurz anbraten. Mit Salz, Pfeffer und Currypulver würzen.',
   'Limettensaft, Soja-Soße und die Kokosmilch dazugeben. Kartoffelstücke dazu geben. Bei kleiner Hitze köcheln lassen bis die Süßkartoffeln fertig sind. Anrichten und servieren.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Gemüsepfanne mit Süßkartoffeln',
prev: 'vegane_gemuesepfannesuesskartoffeln.jpg',
time: '30 min.',
ingredients:
 [ '1 große Süßkartoffel',
   '1 Zwiebel',
   '3 Möhren',
   '1 EL Olivenöl',
   '1 Brokkoli',
   '300 ml gesalzenes Wasser',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Zwiebel und Möhren waschen, schälen und in feine Würfel schneiden. Brokkoli waschen, Stiel abschneiden, schälen, in kleine Würfel schneiden. Brokkoliröschen abschneiden. Süßkartoffel waschen, schälen und in Würfel schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Zwiebel- und Karottenwürfel in die Pfanne geben und anbraten.',
   'Die Kartoffelwürfel dazugeben, kurz mitbraten. Anschließend das gesalzene Wasser dazugeben. Brokkolistücke dazugeben.',
   'Pfanne mit Deckel verschließen und etwa 15 Minuten bei mittlerer Hitze köcheln lassen.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Veganes Tofu Curry',
prev: 'veganes_tofu_curry.jpg',
time: '25 min.',
ingredients:
 [ '300 g Tofu',
   '1 kleines Stück Ingwer (1 cm)',
   '1 Bund Frühlingszwiebeln',
   '2 Möhren',
   '1 gelbe Paprikaschote',
   '30 g Cashewkerne',
   '100 ml gesalzenes Wasser',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Currypulver' ],
preparation:
 [ 'Ingwer schälen und klein hacken. Möhren, Paprikaschote und Frühlingszwiebeln waschen, klein schneiden. Cashewkerne grob hacken. Tofu in Würfel schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Ingwer-, Möhren,- und Paprikastücke in die Pfanne geben und kurz anbraten.',
   'Tofu-Würfel dazugeben. Alle Zutaten mit Salz, Pfeffer und Currypulver würzen. 2 Minuten weiterbraten.',
   '100 ml gesalzenes Wasser in die Pfanne geben. Einkochen lassen. Mit Salz, Pfeffer und Curry abschmecken.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili sin Carne',
prev: 'chili_sin_carne.jpg',
time: '30 min.',
ingredients:
 [ '300 g Tofu',
   '1 Zwiebel',
   '1 Knoblauchzehe',
   '1 rote Paprika',
   '1 rote Peperoni',
   '250 ml passierte Tomaten',
   '1 kleine Dose Maiskörner',
   '1 kleine Dose Kidneybohnen',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Chilipulver' ],
preparation:
 [ 'Tofu in Würfel schneiden. 1 EL Olivenöl mit etwas Chilipulver vermengen und die Tofu-Würfel darin wenden.',
   'Zwiebel und Knoblauchwürfel schälen und feinhacken. Paprika und Chilischote waschen, entkernen, in feine Stücke schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Tofu-Würfel kurz anbraten, salzen, pfeffern und wieder herausnehmen und warmstellen. Zwiebel, Knoblauch und Paprika in die erhitzte Pfanne geben, kurz anbraten. Passierte Tomaten dazugeben, mit Salz und Pfeffer würzen. Bei mittlerer Hitze 5 Minuten köcheln lassen.',
   'Mais und Kidneybohnen abbrausen und dazugeben. Bei mittlerer Hitze weiterkochen. Tofu-Würfel unterheben. Mit Salz, Pfeffer und Chilipulver abschmecken.' ],
portions: 2,
tags: [ 'Fleischlose Alternative', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Pfifferlingspfanne',
prev: 'vegane_pfifferlingspfanne.jpg',
time: '30 min.',
ingredients:
 [ '300 g frische Pfifferlinge',
   '1 Zwiebel',
   '1 Bund Schnittlauch',
   '2 EL Olivenöl',
   '150 ml Sojacreme',
   '1 EL Senf',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Pfifferlinge waschen. Zwiebel schälen und in feine Würfel schneiden. Schnittlauch waschen und in feine Ringe schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Pfifferlinge hinzugeben und kurz anbraten. Zwiebelstückchen dazu geben und kurz mitbraten. Mit Salz und Pfeffer würzen.',
   'Sojacreme hinzugeben und kurz köcheln lassen.',
   'Senf in die Sauce unterrühren, mit Salz und Pfeffer abschmecken. Schnittlauch dazugeben und umrühren.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Quinoa-Gemüse Pfanne',
prev: 'vegane_quinoa_gemuese_pfanne.jpg',
time: '30 min.',
ingredients:
 [ '250 g Brokkoli',
   '1 rote Paprika',
   '1 Knoblauchzehe',
   '1 Möhre',
   '2 EL Olivenöl',
   '75 g Erbsen (aus dem Tiefkühlfach)',
   '200 ml gesalzenes Wasser',
   '100 g Quinoa',
   ',Salz, Pfeffer, Currypulver' ],
preparation:
 [ 'Brokkoli waschen, Stiel abschneiden, schälen und in Röschen schneiden. Die Röschen anschließend&nbsp;ebenfalls klein schneiden.',
   'Paprika waschen, entkernen und in feine Würfel schneiden. Möhre waschen, schälen in feine Scheiben schneiden. Knoblauch schälen, feinhacken.',
   'Quinoa in einem Sieb mit Wasser ausspülen. Etwa 400 ml Wasser in einem Topf aufkochen. Quinoa hinzugeben. 12 Minuten köcheln lassen. Vom Herd nehmen, salzen und weitere 10 Minuten quellen lassen.',
   'Olivenöl in einer Pfanne erhitzen. Paprika, Brokkoli, Möhre und Knoblauch in die Pfanne geben und 5 Minuten bei mittlerer Hitze anbraten. Erbsen dazugeben. Mit Curry, Salz, Pfeffer würzen.',
   'Gesalzenes Wasser dazugeben. Aufkochen lassen. Quinoa dazugeben und 5 Minuten kochen lassen.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Bohnen mit Soja-Creme',
prev: 'bohnen_soja.jpg',
time: '30 min.',
ingredients:
 [ '200 g grüne, dicke Bohnen',
   '1 Zwiebel',
   '1 EL Olivenöl',
   '150 g Erbsen (Dose)',
   '2 Stangen Staudensellerie',
   '1 EL Zitronensaft',
   '100 ml Soja-Creme',
   ',Salz, Pfeffer, Kräuter' ],
preparation:
 [ 'Bohnen waschen. (Je nach Geschmack kann die Schale entfernt werden. Dafür die Bohnen kurz in kochendes Wasser legen und die Schale entfernen). Erbsen abtropfen lassen.',
   'Sellerie waschen, schälen, in kleine Würfel schneiden. Zwiebel schälen, feinhacken.',
   'Olivenöl in einer Pfanne erhitzen. Sellerie und Zwiebel hineingeben, kurz andünsten. Bohnen und Erbsen dazugeben, etwa 1 Minute&nbsp;weiterdünsten.',
   'Zitronensaft dazugeben, einkochen lassen. Soja-Creme dazugeben. Kurz aufkochen lassen. Bei mittlerer Hitze 5 Minuten köcheln lassen.',
   'Nach Wunsch mit Kräutern anrichten und servieren.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Vegane Tofu Gemüse Pfanne',
prev: 'vegane_tofu_gemuese_pfanne.jpg',
time: '35 min.',
ingredients:
 [ '1 Stange Porree',
   '80 g Amaranth',
   '200 g Tofu',
   '1 Paprika',
   '350 g Möhren',
   '1 EL Olivenöl',
   '150 ml Wasser',
   '½ Bund Petersilie',
   '½ Zitrone',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Wasser in einem Topf salzen. Amaranth dazugeben und kurz aufkochen lassen. Das Amaranth rund 20 Minuten bei geringer Hitze aufquellen lassen.',
   'Möhren schälen, in Scheiben schneiden. Porree waschen und in Ringe schneiden. Zitrone waschen und die Schale abreiben. Tofu in Streifen schneiden. Petersilie waschen, kleinhacken. Paprika waschen, entkernen, klein schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Tofu kurz anbraten. Porree dazugeben, kurz andünsten. Anschließend Möhren dazugeben, ebenfalls kurz andünsten. Amaranth mit etwas Wasser dazugeben und 5 Minuten kochen lassen.',
   'Petersilie untermischen. Mit Salz, Pfeffer und Zitronenschale abschmecken.' ],
portions: 2,
tags: [ 'Mit Amaranth', 'Lunch', 'Vegan' ] },
{ name: 'Veganer Curry Eintopf',
prev: 'veganer_curry_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '½ Porree',
   '1 große Süßkartoffel',
   '2 EL Olivenöl',
   '100 g Linsen',
   '1TL Tomatenmark',
   '200 ml Wasser',
   ',Salz, Pfeffer, Currypulver' ],
preparation:
 [ 'Porree waschen, in Ringe schneiden. Süßkartoffel waschen, schälen, in Würfel scheiden.',
   'Olivenöl in einer Pfanne erhitzen. Porree, Süßkartoffel und Linsen kurz anbraten. Tomatenmark dazugeben, mit Curry würzen und mit Wasser ablöschen. Mit Salz und Pfeffer würzen. Unter gelegentlichem Umrühren rund 15 Minuten köcheln lassen.',
   'Mit Salz, Pfeffer und Curry nochmals abschmecken. Nach Belieben mit Kräutern anrichten und servieren.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Karotten Aprikosen Curry',
prev: 'karotten_aprikosen_curry.jpg',
time: '30 min.',
ingredients:
 [ '200 g Tofu',
   '1 große Zwiebel',
   '300 g Karotten',
   '100 g Aprikosen (Dose)',
   '1 Knoblauchzehe',
   '100 ml Kokosmilch',
   '75 ml Wasser',
   '1 EL Olivenöl',
   '1 Chilischote',
   ',Salz, Pfeffer, Currypulver' ],
preparation:
 [ 'Tofu in Streifen schneiden. Aprikosen in feine Würfel schneiden und den Saft aus der Dose aufbewahren. Zwiebel, Karotten und Knoblauch schälen, in feine Würfel schneiden. Chilischote waschen, in feine Ringe schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Die Tofu-Streifen bei mittlerer Hitze von allen Seiten anbraten. Mit Salz und Pfeffer würzen, herausnehmen und warmstellen.',
   'Knoblauch und Zwiebelstückchen in die Pfanne geben und kurz andünsten. Anschließend die Karottenstückchen dazugeben, ebenfalls kurz anbraten. Mit Curry würzen und&nbsp;mit Wasser ablöschen.',
   'Aprikosenstücke und Saft, Chiliringe, Kokosmilch dazugeben. Mit Salz, Pfeffer würzen. Tofu dazu geben und 10 Minuten ziehen lassen.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili con Carne',
prev: 'chili_con_carne.jpg',
time: '25 min.',
ingredients:
 [ '300 g Hackfleisch vom Rind',
   '1 Chilischote',
   '1 Zwiebel',
   '½ Knoblauchzehe',
   '1 große Dose Tomaten',
   '1 TL Chilipulver',
   '1 Dose Kidneybohnen (250g)',
   '2 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Knoblauchzehe und Zwiebel schälen, jeweils in kleine Würfel schneiden. Olivenöl in einer Pfanne erhitzen. Zwiebel und Knoblauch 5 Minuten anschwitzen.',
   'Die Chilischote waschen und klein schneiden. Zusammen mit dem Chilipulver in die Pfanne geben. Etwa 2 Minuten andünsten.',
   'Das Hackfleisch dazugeben und anbraten. Tomaten und Kidneybohnen unterrühren. Mit Salz und Pfeffer abschmecken.',
   'Bei mittlerer Hitze rund 90 Minuten köcheln lassen.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Rindfleisch Paprika Pfanne',
prev: 'rindfleisch_paprika.png',
time: '20 min.',
ingredients:
 [ '2 Stücke Steakfleisch',
   '1 Zwiebel',
   '1 Paprika',
   '1 Peperoni',
   '2 EL Olivenöl',
   ',Bei Belieben: 1 EL Soja Sauce',
   ',Salz und Pfeffer' ],
preparation:
 [ 'Paprika und Peperoni waschen, entkernen und in Streifen schneiden. Zwiebel schälen, in Ringe schneiden. Fleisch in Streifen schneiden.',
   'Olivenöl in der Pfanne erhitzen. Die Fleischstreifen anbraten und mit Salz und Pfeffer würzen. Peperoni, Zwiebel und Paprika dazugeben und kurz anbraten.',
   'Nach Belieben mit Soja Sauce abschrecken und anrichten.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Süßkartoffelspalten',
prev: 'suesskartoffelspalten.jpg',
time: '30 min.',
ingredients:
 [ '3-4 Süßkartoffeln',
   '3 Knoblauchzehen',
   ',Salz, Pfeffer, ggf. Paprikapulver',
   '3 EL Olivenöl',
   '3 EL magerer Kräuterquark' ],
preparation:
 [ 'Die Kartoffeln waschen und in gleich große Spalten schneiden. Auf einem mit Backpapier ausgelegtem Backblech gleichmäßig verteilen.',
   'Backofen auf 200 Grad vorheizen. Knoblauchzehen schälen und in feine Stückchen hacken. Mit Olivenöl vermengen und mit Salz, Pfeffer und Paprikapulver würzen.',
   'Knoblauch-Gewürzmischung gleichmäßig auf die Kartoffelspalten streichen. Im Backofen 15-20 Minuten backen.',
   'Kartoffelspalten mit Kräuterquark anrichten und servieren.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Rotbarsch auf Pfifferlingen',
prev: 'rotbarsch_auf_pfifferlingen.jpg',
time: '30 min.',
ingredients:
 [ '2 Rotbarschhälften (300g)',
   '½ Zwiebel',
   '150 g Pfifferlinge (frisch oder tiefgefroren)',
   '½ Bund Frühlingszwiebeln',
   '200 g kleine Tomaten',
   '2 EL Olivenöl',
   '1 EL Zitronensaft',
   ',Salz und Pfeffer' ],
preparation:
 [ 'Fisch waschen und gegebenenfalls Gräten entfernen.',
   'Filets mit Zitronensaft beträufeln und mit Salz würzen.',
   'Zwiebel schälen, in feine Stückchen hacken. Frühlingszwiebel waschen, in feine Ringe schneiden. Pfifferlinge waschen.',
   'Tomaten waschen. Heißes Wasser aus dem Wasserkocher in eine Schüssel geben. In die Tomaten einen kleinen Schlitz schneiden und in das heiße Wasser geben. Nach einigen Minuten herausnehmen und die Haut abziehen.',
   'Olivenöl in eine Pfanne geben und erhitzen. Zwiebelstückchen dazu geben und glasig dünsten. Anschließend Pfifferlinge dazugeben und etwa 8 Minuten anbraten.',
   'Zu den Pfifferlingen die Frühlingszwiebeln und Tomaten hinzugeben. Etwa 3 Minuten ziehen lassen. Anschließend mit Salz und Pfeffer abschmecken.',
   'In einer separaten Pfanne die Fischfilets in&nbsp;Olivenöl von beiden Seiten 3 Minuten braten.' ],
portions: 2,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Chili con Carne Omelette',
prev: 'chili_con_carne_omelette.jpg',
time: '30 min.',
ingredients:
 [ '4 Eier',
   '1 Zwiebel',
   '1 Knoblauchzehe',
   '2 EL Olivenöl',
   '1 rote Paprika',
   '1 große Dose Tomaten',
   '250 g Rinderhackfleisch',
   '1 Chilischote',
   '1 TL Chilipulver',
   '1 Dose Kidneybohnen (250g)',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Paprika waschen und würfeln. Zwiebel und Knoblauchzehe schälen und in feine Stücke hacken. Chilischote waschen und in feine Ringe schneiden.',
   'Olivenöl in der Pfanne erhitzen und das Hackfleisch anbraten. Die Chili, Zwiebel-, Knoblauch- und Paprikastückchen dazugeben und 2 Minuten mitbraten.',
   'Tomaten und Kidneybohnen aus der Dose dazugeben. Mit Salz, Pfeffer und Chilipulver würzen. Umrühren und einige Minuten köcheln lassen.',
   'In der Zwischenzeit Olivenöl in einer zweiten Pfanne erhitzen. 2 verquirlte Eier bei geringer Hitze zu einem Omelette stocken lassen. Die rohen Eier vorher nach Belieben mit Salz und Pfeffer würzen. Omelette vorsichtig wenden und aus der Pfanne nehmen. Das zweite Omelette auf die gleiche Weise zubereiten.',
   'Das fertige Chili auf den Omelettes verteilen und zuklappen.' ],
portions: 2,
tags:
 [ 'Low Carb', 'Breakfast', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Gefüllte Couscous Paprika mit Feta',
prev: 'couscous_paprika_mit_feta.jpg',
time: '30 min.',
ingredients:
 [ '2 Paprika',
   '100 g roher Couscous',
   '1 EL Olivenöl',
   '100 g Fetakäse',
   '50 g Oliven (entsteint)',
   '3 Cherry-Tomaten',
   ',Salz, Pfeffer, Basilikum' ],
preparation:
 [ 'Paprika halbieren, entkernen und waschen.',
   'Gesalzenes Wasser in einem Topf zum Kochen bringen. Topf vom Herd&nbsp;nehmen und Couscous unter Rühren dazugeben. Mit einem Deckel verschließen und bei schwacher Hitze 5 Minuten quellen lassen.',
   'Fetakäse würfeln. Oliven waschen und in feine Stücke schneiden. Tomaten waschen, in feine Stücke schneiden. Käse, Oliven und Tomaten mit Couscous vermengen. Mit Salz, Pfeffer und Basilikum würzen.',
   'Backofen auf 200 Grad Celsius vorheizen. Paprikaschoten mit Couscous-Feta Mischung befüllen. In den Backofen legen und 20 Minuten backen' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Kasseler in Apfel Senf Sauce',
prev: 'kasseler_apfel.jpg',
time: '30 min.',
ingredients:
 [ '2 Kasseler-Koteletts ohne Knochen',
   '2 Äpfel',
   '100 ml Gemüsebrühe',
   '2 EL Zitronensaft',
   '2 EL Senf',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Äpfel waschen, schälen und in kleine Würfel schneiden. Anschließend mit Zitronensaft beträufeln.',
   'Pfanne mit Olivenöl erhitzen und von jeder Seite rund 3 Minuten braten. Apfelwürfel dazu geben und bei niedriger Wärme weitere 7 Minuten braten. Mit Salz und Pfeffer würzen.',
   'Kasselerscheiben aus der Pfanne nehmen und warmhalten. Die Apfelwürfel mit der Gemüsebrühe ablöschen. Senf einrühren und gegebenenfalls erneut mit Salz und Pfeffer abschmecken. Kasseler in die Pfanne legen und 10 Minuten ziehen lassen.',
   'Servieren und genießen!' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Lachs auf Wirsing',
prev: 'lachs_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '350 g Wirsing',
   '4 EL fettarme Sahne',
   '300 g Lachsfilet ohne Haut',
   '2 TL Olivenöl',
   '1 Zitrone in Scheiben',
   '50 ml fettarme Milch',
   '1 TL Dill',
   ',Currypulver, Muskatnuss, Salz, Pfeffer' ],
preparation:
 [ 'Wirsing waschen und in Streifen schneiden. Salzwasser zum Kochen bringen. Wirsing-Streifen hinzufügen und kochen lassen bis die Streifen weich sind.',
   'Sahne und Milch in einen&nbsp;weiteren Topf geben und erhitzen. Einkochen lassen bis die Hälfte verdampft ist. Den Wirsing dazugeben und mit Curry, Muskat, Salz und Pfeffer würzen.',
   'Olivenöl in einer Pfanne erhitzen. Die Lachsfilets bei mittlerer Hitze rund 3 Minuten braten. Mit Salz und Pfeffer würzen.',
   'Alles auf einem Teller anrichten und Lachs mit Zitronenscheiben belegen, Dill bestreuen.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Buntes Ofengemüse',
prev: 'buntes_ofengemuese.jpg',
time: '35 min.',
ingredients:
 [ '1 Zucchini',
   '1 rote Paprika',
   '1 gelbe Paprika',
   '300 g Champignons',
   '4 Tomaten',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Kräuter z.B. Kräuter der Provence' ],
preparation:
 [ 'Backofen auf 200 Grad Celsius vorheizen.',
   'Gemüse waschen und in Scheiben schneiden. Tomaten achteln.',
   'Backblech mit Backpapier auslegen und mit Öl einpinseln. Gemüse auf das Backblech legen. Mit Salz, Pfeffer und Kräutern nach Belieben würzen.',
   '20 Minuten backen.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Curry Bohnen Eintopf',
prev: 'burry_bohnen_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '1 Zucchini',
   '1 Zwiebel',
   '1 Paprika',
   '500 ml Wasser',
   '1 Dose weiße Bohnen',
   '1 Bund Suppengemüse: 2 Möhren, ½ Stange Porree, 1 Stück Sellerie',
   ',Nach Belieben: 2 Stück Wiener Würstchen (fettarmes Putenfleisch)',
   ',Salz, Pfeffer, Curry' ],
preparation:
 [ 'Gemüse waschen, klein schneiden. Olivenöl in einem Topf erhitzen. Gemüse dazu geben und kurz anbraten. Mit Salz, Pfeffer und Curry würzen. Das Wasser dazu geben und rund 20 Minuten köcheln lassen.',
   'Bohnen mit Wasser abwaschen, anschließend&nbsp;in den Topf geben. Rund 10 Minuten köcheln lassen.',
   'Servieren und anrichten. Wer mag kann fettarme Putenwurststückchen hineinschneiden.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Garnelenpfanne',
prev: 'garnelenpfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g Garnelen (frisch oder tiefgefroren)',
   '250 g Kirschtomaten',
   '250 g Pilze',
   '1 Zitrone',
   '1 TL Senf',
   '4 Lauchzwiebeln',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Petersilie' ],
preparation:
 [ 'Tiefgefrorene Garnelen vor der Zubereitung auftauen lassen.',
   'Olivenöl in einer Pfanne erhitzen. Garnelen kurz anbraten und mit Zitronensaft ablöschen.',
   'Pilze, Tomaten und Lauchzwiebel waschen. Pilze und Tomaten halbieren. Lauchzwiebel in Ringe schneiden. Pilze in die Pfanne geben und kurz anbraten.',
   'Kirschtomaten und die Lauchzwiebeln in die Pfanne geben. Kurz andünsten.',
   'Mit Salz, Pfeffer und Senf würzen. Anrichten und mit Petersilie bestreuen.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch' ] },
{ name: 'Kräuter Lachs mit Bohnen',
prev: 'krrauter_lachs_mit_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '2 Lachssteaks ohne Haut',
   '40 g Oliven',
   '200 g grüne Bohnen',
   '1 EL fettarmer Frischkäse',
   '2 TL Kräuterbutter',
   '4 Cherrytomaten',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Lachssteaks mit Salz und Pfeffer würzen. Oliven waschen und in feine Ringe schneiden. Oliven mit der Kräuterbutter und dem Frischkäse verrühren. Mit Salz und Pfeffer würzen.',
   'Bohnen waschen und bei mittlerer Hitze in gesalzenem Wasser kochen.',
   'Tomaten waschen, halbieren. Zusammen mit den Lachssteaks in eine Grillpfanne geben und den Fisch&nbsp;von beiden Seiten rund 3 bis 4 Minuten anbraten.',
   'Lachssteaks auf Tellern anrichten. Kräuterbutter-Frischkäse-Creme auf dem Fisch&nbsp;schmelzen lassen. Bohnen dazugeben und servieren.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Falafelpizza',
prev: 'falafelpizza.jpg',
time: '30 min.',
ingredients:
 [ '1 Ei',
   '1 Zwiebel',
   '1 Packung Falafelmischung',
   '3 Tomaten',
   '2 Scheiben Schinken',
   '1 Paprika',
   '100 g Champignons' ],
preparation:
 [ 'Zwiebel schälen und in feine Stücke hacken. Tomaten und Champignons waschen, in kleine Stücke schneiden. Paprika waschen, entkernen und in feine Streifen schneiden. Schinkenscheiben in kleine Stücke schneiden.',
   'Backofen auf 200 Grad Celsius vorheizen.',
   'Falafelmischung nach Packungsanweisung zubereiten. Kurz quellen lassen.',
   'Die vorbereitete Falafelmischung mit den Zwiebelwürfeln und dem Ei vermengen. Anschließend auf ein mit Backpapier ausgelegtes Backblech streichen und rund 5 Minuten anbacken.',
   'Den Falafel-Pizzaboden&nbsp;aus&nbsp;dem Backofen nehmen und mit Schinken und Gemüse belegen. Ggf. mit Parmesan bestreuen. Wieder in den Backofen schieben und weitere 10 Minuten backen.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Putenwraps',
prev: 'putengeschnetzeltes_mit_tomaten.jpg',
time: '30 min.',
ingredients:
 [ '4 Eier',
   '2 EL gemahlene Mandeln',
   '1 EL Olivenöl',
   '200 g Putengeschnetzeltes',
   '4 Kirschtomaten',
   '1 Paprika',
   '2 TL Senf',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Olivenöl in einer Pfanne vorheizen.',
   'Die Eier und die gemahlenen Mandeln gut miteinander vermischen. Nach Belieben mit Salz und Pfeffer würzen.',
   'Die Hälfte der Flüssigkeit in die Pfanne geben. Durch Schwenken in der Pfanne verteilen. Bei mittlerer Hitze aufstocken lassen. Den Vorgang für den zweiten Wrap-Boden wiederholen.',
   'Tomaten waschen und in kleine Stücke schneiden. Paprika waschen, entkernen und in kleine Stücke schneiden.',
   'In einer anderen Pfanne Olivenöl erhitzen. Putengeschnetzeltes hineingeben und kurz anbraten. Mit Salz und Pfeffer würzen.',
   'Beide Wrap-Böden jeweils mit Senf bestreichen. Mit Putenfleisch und Gemüse belegen. Zusammenrollen und genießen.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch', 'Snacks' ] },
{ name: 'Curry Kokos Linsentopf',
prev: 'kokos_linsen.jpg',
time: '20 min.',
ingredients:
 [ '1 große Dosen Linsen',
   '½ Bund Lauchzwiebeln',
   '2 EL Currypulver',
   '1 TL Cayenne-Pfeffer',
   '1 TL Kreuzkümmel',
   '½ Dose Kokosmilch',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Olivenöl in einer Pfanne erhitzen.',
   'Lauchzwiebeln waschen und in Ringe schneiden. In die Pfanne geben und kurz andünsten. Kokosmilch und Linsen dazugeben. Mit Gewürzen nach Belieben abschmecken. 15-20 Minuten köcheln lassen.' ],
portions: 1,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Gemüse Lachs Pfanne',
prev: 'lachsfilet_auf_gemuese.jpg',
time: '30 min.',
ingredients:
 [ '1 Zucchini',
   '150 g Lachs (ohne Haut)',
   '1 Möhre',
   '1 Brokkoli',
   '1 Zwiebel',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Gemüse waschen und in kleine Stücke schneiden. Möhre und Zwiebel schälen, in feine Stücke schneiden. Olivenöl in einer Pfanne vorheizen.',
   'Lachs in die Pfanne geben und bei mittlerer Hitze von beiden Seiten anbraten. Nach 3 Minuten das Gemüse in die Pfanne geben und ebenfalls anbraten. Gelegentlich mit Wasser ablöschen.',
   'Mit Salz und Pfeffer würzen.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Puten Kokos Pfanne',
prev: 'puten_kokos_pfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g Putengeschnetzeltes',
   '1 Dose Champignons',
   '1 Frühlingszwiebel',
   '1 kleine Dose grüne Bohnen',
   '250 ml passierte Tomaten',
   '20 ml Kokosmilch',
   '2 EL Tomatenpesto',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Frühlingszwiebel waschen und in feine Ringe schneiden. Champignons und Bohnen abtropfen lassen. Olivenöl in einer Pfanne erhitzen.',
   'Putengeschnetzeltes und die Zwiebelringe bei mittlerer Hitze anbraten. Passierte Tomaten, die Kokosmilch und das Pesto dazugeben.',
   'Pilze und Bohnen dazugeben. Mit Salz und Pfeffer würzen. Rund 10 Minuten bei mittlerer Hitze köcheln lassen.' ],
portions: 2,
tags: [ 'Superschnell', 'Lunch' ] },
{ name: 'Putengeschnetzeltes mit Erdnuß-Sauce',
prev: 'putengeschnetzeltes_mit_curry_kokosmilch.jpg',
time: '30 min.',
ingredients:
 [ '400 Putengeschnetzeltes',
   '200 ml Kokosmilch',
   '250 ml Gemüsebrühe',
   '4 EL Erdnussbutter (ungesüßt)',
   '2 Möhren',
   '1 Knoblauchzehe',
   '1 Chilischote',
   '1 Lauchzwiebel',
   '200 g Brokkoli',
   '½ Zitrone',
   '2 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Brokkoli und Lauchzwiebel waschen, in Scheiben schneiden. Möhre waschen, schälen und in Scheiben schneiden. Zitronensaft auspressen. Olivenöl in einer Pfanne erhitzen.',
   'Gemüse und Putengeschnetzeltes in die Pfanne geben, kurz anbraten. 150 ml Wasser in die Pfanne geben. Wenige Minuten köcheln lassen bis das Wasser verdampft ist.',
   'Chilischote waschen, in feine Ringe schneiden. Knoblauchzehe schälen, in feine Stücke hacken. Olivenöl in einem Topf erhitzen. Chilischeiben und Knoblauchstücke kurz im&nbsp;Topf anbraten. Kokosmilch hinzugeben und kurz aufkochen lassen.',
   'Topf vom Herd nehmen. Erdnussbutter und Zitronensaft dazugeben. Mit Salz und Pfeffer würzen.',
   'Gemüse und Putengeschnetzeltes mit der Erdnuss-Sauce anrichten.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch' ] },
{ name: 'Rinderfilet auf Paprikagemüse',
prev: 'rinderfilet_auf_paprikagemuse.jpg',
time: '30 min.',
ingredients:
 [ '2 Rinderfilets',
   '3 Paprika (rot, gelb)',
   '1 Zwiebel',
   '150 g Champignons',
   '1 Knoblauchzehe',
   '1 EL Olivenöl',
   ',Salz, Pfeffer, Paprikapulver' ],
preparation:
 [ 'Olivenöl in einer Pfanne erhitzen. Knoblauchzehe schälen, feinhacken. Paprika waschen, entkernen, in Streifen schneiden. Zwiebel schälen, in feine Stücke hacken. Champignons waschen, fein schneiden.',
   'Rinderfilets mit Salz und Pfeffer würzen. Knoblauchstücke in der Pfanne kurz andünsten. Rinderfilets dazugeben und rund 7 Minuten von jeder Seite anbraten. Herausnehmen und warmstellen.',
   'Paprika, Champignons und Zwiebel in die erhitzte Pfanne geben und 5 Minuten anbraten. Mit Salz und Pfeffer würzen.',
   'Gebratenes Gemüse mit Rinderfilets anrichten.' ],
portions: 2,
tags: [ 'Für Feinschmecker', 'Lunch' ] },
{ name: 'Bratkohlrabi',
prev: 'bratkohlrabi.jpg',
time: '30 min.',
ingredients:
 [ '1 Zwiebel',
   '1 Kohlrabi',
   '2 Scheiben Kochschinken',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Kohlrabi schälen und in dünne Scheiben schneiden. Zwiebel schälen und in feine Scheiben schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Kohlrabischeiben in die Pfanne geben und bei mittlerer Hitze braten bis sie weich sind. In der Zwischenzeit den Schinken in Streifen schneiden.',
   'Zwiebelringen und Schinkenstreifen zu den Kohlrabischeiben geben und mit Salz und Pfeffer würzen.' ],
portions: 2,
tags: [ 'Low Carb', 'Lunch', 'Snacks' ] },
{ name: 'Scharfer Kichererbsensalat',
prev: 'scharfer_kichererbsensalat.jpg',
time: '10 min.',
ingredients:
 [ '300 g vorgekochte Kichererbsen',
   '1 Zwiebel',
   '4 Cherrytomaten',
   '1 Paprika (rot/gelb)',
   '1 Knoblauchzehe',
   '1 EL Tomatenmark',
   '1 EL Olivenöl',
   '1 EL Sojasauce',
   '1 EL Kräuter (z.B. Petersilie)',
   ',Salz, Pfeffer, Paprikapulver' ],
preparation:
 [ 'Knoblauch und Zwiebel schälen, feinhacken. Anschließend mit dem Tomatenmark, Olivenöl, der Sojasauce vermischen. Mit Paprikapulver würzen.',
   'Paprika und Tomaten waschen, klein schneiden. Mit Kichererbsen vermengen und Dressing darüber geben. Kräuter zum Schluss untermischen. Mit Salz und Pfeffer abschmecken.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Gurken Lachs Baguette',
prev: 'gurken_lachs.jpg',
time: '10 min.',
ingredients:
 [ '1 große Salatgurke',
   '250 g Lachs',
   '8 EL Hüttenkäse',
   '2 EL Petersilie (frisch oder getrocknet)',
   '1 Knoblauchzehe',
   '½ Zitrone',
   '2 EL Erbsen aus der Dose',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Knoblauch schälen, feinhacken.',
   'Gurke waschen, schälen, halbieren. Das Innere der Gurke mit einem Messer vorsichtig herausschneiden und in feine Stücke hacken.',
   'Zitrone auspressen. Den Zitronensaft&nbsp;mit Hüttenkäse, Knoblauch, Erbsen, Petersilie und Gurkenstückchen vermengen.',
   'Gurkenhälften mit der Creme bestreichen und mit Räucherlachs belegen.' ],
portions: 2,
tags: [ 'Leicht', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Thunfisch Hüttenkäse Snack',
prev: 'thunfisch_huettenkaese.png',
time: '5 min.',
ingredients:
 [ '250 g Hüttenkäse',
   '1 Dose Thunfisch (ohne Öl)',
   '150 g Quark',
   '1 Lauchzwiebel',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Lauchzwiebel waschen, in feine Ringe schneiden. Thunfisch abtropfen lassen.',
   'Thunfisch, Quark und Lauchzwiebeln in einer Schüssel miteinander vermengen.',
   'Mit Salz und Pfeffer abschmecken.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Gemüsesticks mit Dip',
prev: 'gemuesesticks.png',
time: '10 min.',
ingredients:
 [ '1 Paprika',
   '½ Salatgurke',
   '2 Karotten',
   '½ Bund Radieschen',
   '½ Zucchini',
   '250 g Magerquark',
   '½ Bund Schnittlauch',
   '½ Chilischote (alternativ Chilipulver)',
   ',Salz, Pfeffer, Zitronensaft' ],
preparation:
 [ 'Gemüse waschen, schälen und in feine Streifen schneiden.',
   'Schnittlauch und Chilischote waschen, in feine Ringe schneiden.',
   'Magerquark mit Schnittlauch und Chilischoten vermengen. Mit Salz und Pfeffer würzen. Nach Belieben einen Spritzer Zitronensaft unterrühren. Dip in einer kleinen Schüssel mit den Gemüsesticks servieren.' ],
portions: 1,
tags: [ 'Leicht', 'Dinner', 'Snacks' ] },
{ name: 'Champignon Avocado Snack',
prev: 'champignon_avocado_snack.jpg',
time: '25 min.',
ingredients:
 [ '1 Avocado',
   '100 g Champignons',
   '½ Eisbergsalat',
   '1 Möhre',
   '1 Tomate',
   '1 Handvoll Cashew Kerne',
   '2 EL Olivenöl',
   '4 EL Magerquark',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Eisbergsalat waschen, schneiden und in eine Schüssel geben. Möhre, Tomate waschen und in kleine Stücke schneiden. Zur Schüssel hinzufügen.',
   'Avocado halbieren, Kern entfernen und Avocadofleisch mit einem Löffel entnehmen. Das Avocadofleisch aus einer Hälfte mit einer Gabel zu Brei verarbeiten und die andere Hälfte in kleine Stücke schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Champignons waschen, schneiden. In die Pfanne geben und kurz anbraten. Champignons über den restlichen Salat geben.',
   'Avocadobrei mit Magerquark vermischen. Cashewkerne feinhacken und zur Avocado-Quark-Mischung dazugeben. Mit Salz und Pfeffer abschmecken. Das Dressing über den Salat geben.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks' ] },
{ name: 'Bunter Salat mit Kokos-Coacktailsauce',
prev: 'salat_mit_kokos_coacktailsauce.jpg',
time: '10 min.',
ingredients:
 [ '½ Eisbergsalat',
   '2 Tomaten',
   '30 g Schinken',
   '½ Salatgurke',
   '2 gekochte Eier',
   '200 ml Kokosmilch',
   '1 EL Tomatenmark',
   '½ TL Senf',
   ',Salz, Pfeffer, Curry, Paprikapulver' ],
preparation:
 [ 'Gemüse waschen, schälen und in kleine Stücke schneiden. Eier schälen, klein schneiden. Schinken in Streifen schneiden. Alle Zutaten in eine Schüssel geben.',
   'Tomatenmark, Kokosmilch und Senf gut miteinander verrühren. Nach Belieben würzen.',
   'Dressing über den Salat geben.' ],
portions: 1,
tags: [ 'Exotisch', 'Dinner', 'Snacks' ] },
{ name: 'Thunfisch Bohnen Salat',
prev: 'thunfisch_bohnen.jpg',
time: '10 min.',
ingredients:
 [ '½ Dose Thunfisch im eigenen Saft',
   '3 Cherrytomaten',
   '80 g Kidneybohnen',
   '1 Zwiebel',
   '50 g Mais',
   ',¼ Bund Petersilie',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Tomaten waschen und klein schneiden. Zwiebel schälen, feinhacken. Bohnen und Mais abtropfen lassen. Petersilie waschen, feinhacken.',
   'Gemüse in eine Schüssel geben. Olivenöl darüber geben. Mit Salz und Pfeffer abschmecken.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Protein Power Salat',
prev: 'protein_power.jpg',
time: '25 min.',
ingredients:
 [ '2 Eier',
   '1 Stück Hähnchenfilet',
   '1 Frühlingszwiebel',
   '1 EL Sonnenblumenkerne',
   '1 Tomate',
   '½ Salatgurke',
   '1 EL Naturjogurt',
   '1 EL Essig',
   '2 EL Olivenöl',
   '1/2 TL Senf',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Tomate, Frühlingszwiebel, Gurke waschen und fein schneiden. Hähnchenfilet in Streifen schneiden. Wasser in einem Topf erhitzen und Eier 10 Minuten kochen. Eier schälen und klein schneiden. Alle Zutaten in eine Schüssel geben.',
   'Olivenöl in einer Pfanne erhitzen. Hähnchenstreifen kurz anbraten. Mit Salz und Pfeffer würzen. Hähnchenstreifen in die Schüssel geben.',
   'Joghurt, Essig, 1 EL Olivenöl und Senf miteinander vermischen. Mit Salz und Pfeffer würzen, zum Salat geben. Salat nach Belieben mit Sonnenblumenkernen bestreuen.' ],
portions: 1,
tags: [ 'Mit Hähnchenfilet', 'Dinner', 'Snacks' ] },
{ name: 'Avocado Steak Salat',
prev: 'avocado_steak.jpg',
time: '30 min.',
ingredients:
 [ '1 Rindersteak',
   '2 EL Olivenöl',
   '4 Cherrytomaten',
   '½ Zwiebel',
   ',¼ Kopf Eisbergsalat',
   '½ Salatgurke',
   '½ Avocado',
   '1 TL Honig',
   '1 EL Zitronensaft',
   ',Salz, Pfeffer, Chilipulver' ],
preparation:
 [ 'Olivenöl in einer Pfanne erhitzen. Steak mit Salz und Pfeffer würzen und bei mittlerer Hitze 4-6 Minuten von jeder Seite anbraten.',
   'Zitronensaft mit Honig und 1 EL Olivenöl in einer kleinen Schüssel vermischen. Mit Chilipulver und Pfeffer würzen.',
   'Gemüse waschen. Salat in mundgerechte Stücke schneiden. Avocado schälen, entkernen und in feine Stücke schneiden. Cherrytomaten halbieren. Zwiebel und Gurke in feine Scheiben schneiden. Steak ebenfalls in mundgerechte Stücke schneiden. Alle Zutaten in eine Schüssel geben und mit dem Dressing übergießen.' ],
portions: 1,
tags: [ 'Für Feinschmecker', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Tofu Ei Salat mit Quinoa',
prev: 'tofu_ei_salat_mit_quinoa.jpg',
time: '15 min.',
ingredients:
 [ '100 g Tofu',
   '50 g Quinoa (roh)',
   '1 Ei',
   '2 Stangen Frühlingszwiebeln',
   '1 Tomate',
   '½ Paprika',
   '1 EL Olivenöl',
   '2 EL Zitronensaft',
   '1 Stange Petersilie',
   ',Pfeffer' ],
preparation:
 [ 'Quinoa 10 Minuten in gesalzenem Wasser gar kochen. Ei ebenfalls rund 10 Minuten hart kochen.',
   'Tofu würfeln. Tomaten und Paprika waschen, in kleine Stücke schneiden. Frühlingszwiebel waschen, in feine Ringe schneiden. Petersilie waschen, feinhacken.',
   'Olivenöl mit Zitronensaft vermischen. Mit Pfeffer würzen. Gekochtes Ei kleinschneiden.',
   'Quinoa mit Gemüse und dem Ei in einer Schüssel miteinander vermischen. Das Dressing darüber geben und servieren.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Spiegelei mit grünen Bohnen und Bacon',
prev: 'spiegelei_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '1-2 Eier',
   '200 g grüne Bohnen',
   '50 g Bacon oder Schinken',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Grüne Bohnen waschen und die&nbsp;Enden abschneiden. Topf mit gesalzenem Wasser erhitzen und die Bohnen bei mittlerer Hitze 10 Minuten kochen lassen. Bacon in kleine Stücke schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Bacon-Stücke kurz anbraten und herausnehmen. Anschließend das Ei in die Pfanne geben. Mit Salz und Pfeffer würzen und zu einem Spiegelei aufstocken lassen.',
   'Grüne Bohnen, Bacon&nbsp;und Spiegelei auf einem Teller anrichten. Gegebenenfalls mit Salz und Pfeffer nachwürzen.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Karotten Zucchini Puffer',
prev: 'karotten_zucchini_puffer.jpg',
time: '20 min.',
ingredients:
 [ '150 g Karotten',
   '½ Zucchini',
   '½ EL Zitronensaft',
   '1 EL Petersilie',
   '1 Ei',
   '4 EL Haferflocken',
   '2 EL fettarmen Kräuterquark',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Karotten und Zucchini waschen, schälen und mit einer Gemüseraspel fein raspeln.',
   'Geraspeltes Gemüse mit Zitronensaft, gehackter Petersilie, Ei und den Haferflocken vermischen. Mit Salz und Pfeffer würzen.',
   'Olivenöl in einer Pfanne erhitzen. Mit einem Löffel kleine Portionen herausstechen und in die erhitzte Pfanne geben. Den Teig ein wenig flach drücken und die Puffer von beiden Seiten bei mittlerer Hitze kurz anbraten.',
   'Die Gemüsepuffer mit Kräuterquark auf einem Teller anrichten.' ],
portions: 1,
tags: [ 'Low Carb', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Basilikum Bohnen Salat',
prev: 'basilikum_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '200 g grüne Bohnen',
   '1 TL Pinienkerne',
   ',¼ Bund Basilikum',
   '½ Knoblauchzehe',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Grüne Bohnen waschen, Enden abschneiden und 10 Minuten in gesalzenem Wasser kochen.',
   'Basilikum waschen, Blätter abzupfen und feinhacken. Knoblauchzehe schälen, pressen.',
   'Knoblauch, Basilikum mit Olivenöl vermengen. Über die gekochten Bohnen geben und anschließend mit Pinienkernen bestreuen.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Spinat-Spiegelei ',
prev: 'spinat_spiegelei.jpg',
time: '15 min.',
ingredients:
 [ '3 Eier',
   '3 EL fettarmer Joghurt',
   '150 g Spinat (tiefgekühlt oder frisch)',
   '1 TL Olivenöl',
   ',Paprikapulver, Chilipulver, Salz, Pfeffer' ],
preparation:
 [ 'Olivenöl in einer Pfanne erhitzen. Spinat in die Pfanne geben. Kurz anbraten. Spinat in der Pfanne an die Seite schieben.',
   'Eier in der Pfanne aufschlagen und aufstocken lassen. Mit Salz und Pfeffer würzen.',
   'Chilipulver mit Joghurt verrühren. Anschließend mit Salz, Pfeffer und Paprikapulver abschmecken. Zu den Eiern und dem Spinat servieren.' ],
portions: 1,
tags:
 [ 'Voller Mineralstoffe', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Beerenmüsli',
prev: 'beerenmuesli.png',
time: '10 min.',
ingredients:
 [ '50 g Haferflocken',
   '30 g Mandeln',
   '150 g Beeren (frisch oder gefroren)',
   '250 g Magerquark',
   '150 ml fettarme Milch' ],
preparation:
 [ 'Mandeln in einer Pfanne bei mittlerer Hitze rund 4 Minuten kurz anrösten. Anschließend feinhacken. Beeren waschen.',
   'Haferflocken, gehackte Mandeln, frische (oder aufgetaute Beeren), Milch und Magerquark mit einander vermengen.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Mediterranes Rührei',
prev: 'mediteranes_ruehrei.png',
time: '15 min.',
ingredients:
 [ '3 Eier',
   '4 Cherrytomaten',
   '20 g Rucola',
   '100 g fettarmer Feta',
   '1 EL Olivenöl',
   ',Pfeffer' ],
preparation:
 [ 'Tomaten und Rucola waschen. Tomaten vierteln und Rucola feinhacken. Fetakäse in kleine Würfel schneiden.',
   'Eier und Rucola in eine Schüssel geben, verquirlen und mit Pfeffer würzen.',
   'Olivenöl in einer Pfanne erhitzen. Tomaten in die Pfanne geben und kurz anbraten. Eier in die Pfanne geben und aufstocken lassen. Mit Pfeffer würzen.',
   'Rührei auf einem Teller servieren und mit Feta-Stückchen bestreuen.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Nuss Apfel Müsli',
prev: 'nuss_apfel_muesli.jpg',
time: '5 min.',
ingredients:
 [ '1 Apfel',
   '30 g Walnüsse',
   '50 g Haferflocken',
   '200 g Magerquark',
   '150 ml fettarme Milch',
   ',Zimt' ],
preparation:
 [ 'Apfel waschen, in kleine Stücke schneiden. Nüsse kleinhacken.',
   'Haferflocken, Apfelstücke, Walnüsse mit Magerquark und Milch mischen. Müsli mit Zimt bestreuen.' ],
portions: 1,
tags: [ 'Sättigend', 'Breakfast', 'Snacks' ] },
{ name: 'Bacon and Eggs',
prev: 'bacon_eggs.png',
time: '10 min.',
ingredients:
 [ '3 Eier',
   '4 fettarme Baconstreifen',
   '1 EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Olivenöl in einer Pfanne erhitzen. Baconstreifen kurz anbraten, herausnehmen und warmhalten.',
   'Eier in die Pfanne geben, zu Spiegeleiern aufstocken lassen. Mit Salz und Pfeffer würzen.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Minz Gurken Shake ',
prev: 'minz_gurke.jpg',
time: '5 min.',
ingredients:
 [ '250 g Magerquark',
   '1 Handvoll frische Minze',
   '½ Salatgurke',
   '½ Zitrone',
   '200 ml Wasser' ],
preparation:
 [ 'Die Salatgurke und Minzblätter waschen. Salatgurke in kleine Stücke schneiden. Zitrone auspressen.',
   'Alle Zutaten in einen hohen Behälter geben und mit einem Pürierstab fein pürieren.' ],
portions: 1,
tags: [ 'Erfrischend', 'Dinner', 'Drink' ] },
{ name: 'Pfirsich Gurken Shake',
prev: 'pfirsich_gurke.jpg',
time: '10 min.',
ingredients:
 [ '2 Pfirsiche',
   ',¼ Salatgurke',
   '50 ml Wasser',
   '200 g Naturjoghurt',
   '1 TL Honig' ],
preparation:
 [ 'Pfirsiche und Salatgurke waschen, in kleine Stücke schneiden.',
   'Naturjoghurt und Wasser zusammen mit den Pfirsich-und Gurkenstückchen in ein hohes Gefäß geben. Mit einem Stabmixer pürieren. Nach Belieben mit Honig süßen.',
   'Kalt servieren.' ],
portions: 1,
tags: [ 'Einfach', 'Dinner', 'Drink' ] },
{ name: 'Limetten Ingwer Eistee',
prev: 'limetten_ingwer.jpg',
time: '15 min.',
ingredients:
 [ '4 Beutel grüner Tee',
   '2 Limetten',
   '35 g frischen Ingwer',
   '500 ml Wasser',
   '2 TL Honig',
   ',Eiswürfel' ],
preparation:
 [ 'Ingwer waschen, schälen, in feine Scheiben schneiden. Limetten waschen, in feine Scheiben schneiden.',
   'Wasser in einem Wasserkocher aufkochen lassen. In ein großes Gefäß geben. Ingwer- und Limettenscheiben dazugeben und etwa 5 Minuten ziehen lassen.',
   'Teebeutel dazugeben und weitere 5 Minuten ziehen lassen. Teebeutel herausnehmen und bei Belieben mit 2 TL Hönig süßen. Tee abkühlen lassen.',
   'Tee mit Eiswürfeln kalt servieren.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Zitronen Eistee',
prev: 'zitronen_eistee.jpg',
time: '15 min.',
ingredients:
 [ '4 Beutel schwarzer Tee',
   '1 Orange',
   '1 Zitrone',
   '500 ml Wasser',
   ',Eiswürfel' ],
preparation:
 [ 'Orange und Zitrone waschen und in feine Scheiben schneiden.',
   'Wasser in einem Wasserkocher aufkochen und in ein großes Gefäß geben. Teebeutel hineingeben und 5 Minuten ziehen lassen. Beutel herausnehmen.',
   'Die Zitronen- und Orangenscheiben in den warmen Tee geben. Abkühlen und ziehen lassen.',
   'Mit Eiwürfeln in einem Glas servieren.' ],
portions: 4,
tags: [ 'Erfrischend', 'Drink' ] },
{ name: 'Zitronen Blaubeer Eistee',
prev: 'zitronen_blaubeer.jpg',
time: '15 min.',
ingredients:
 [ '4 Beutel grüner Tee',
   '200 g Blaubeeren',
   '1 Zitrone',
   '500 ml Wasser',
   ',Eiswürfel' ],
preparation:
 [ 'Zitrone und Blaubeeren waschen. Zitrone in feine Scheiben schneiden.',
   'Wasser in einem Wasserkocher aufkochen und in ein großes Gefäß geben. Teebeutel hineingeben&nbsp;und etwa 5 Minuten ziehen lassen. Teebeutel anschließend wieder herausnehmen.',
   'Zitronenscheiben und Blaubeeren in den Tee geben. Tee im Kühlschrank abkühlen und ziehen lassen.',
   'Mit Eiwürfeln in einem Glas servieren.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Ananas Orangen Smoothie',
prev: 'ananas_orange.jpg',
time: '5 min.',
ingredients:
 [ '150 g Ananas (3-4 Ringe einer Ananas)',
   '1 Orange',
   '100 g Spinat',
   '250 ml Wasser' ],
preparation:
 [ 'Spinat und Orange waschen. Orange schälen, in kleine Stücke schneiden. Ananas in kleine Stücke schneiden.',
   'Wasser, Obst und Gemüse in ein hohes Gefäß geben. Mit einem Pürierstab pürieren.' ],
portions: 1,
tags: [ 'Exotisch', 'Drink', 'Vegan' ] },
{ name: 'Beeren Power Smoothie',
prev: 'beeren_power.jpg',
time: '5 min.',
ingredients:
 [ '250g Beeren (z.B. Erdbeeren)',
   '½ Mango',
   '250ml Wasser',
   '100 g Spinat' ],
preparation:
 [ 'Beeren, Spinat und Mango waschen. Mango schälen, in kleine Stücke schneiden.',
   'Wasser, Obst und Gemüse in ein hohes Gefäß geben. Mit einem Pürierstab pürieren.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Drink', 'Vegan' ] },
{ name: 'Birnen Bananen Smoothie',
prev: 'birnen_bananen.jpg',
time: '5 min.',
ingredients: [ '2 Birnen', '1 Banane', '100 g Spinat', '250 ml Wasser' ],
preparation:
 [ 'Birnen und Spinat waschen. Banane schälen. Obst in kleine Stücke schneiden.',
   'Wasser, Obst und Gemüse in ein hohes Gefäß geben. Mit einem Pürierstab pürieren.' ],
portions: 1,
tags: [ 'Fruchtig', 'Drink', 'Vegan' ] },
{ name: 'Petersilie Apfel Smoothie',
prev: 'petersilie_apfel.jpg',
time: '5 min.',
ingredients: [ '3 Äpfel', '150 g Petersilie', '10 g Ingwer' ],
preparation:
 [ 'Ingwer waschen, schälen, fein schneiden. Äpfel und Petersilie waschen. Äpfel klein schneiden.',
   'Alle Zutaten in ein hohes Gefäß geben. Mit einem Pürierstab pürieren.' ],
portions: 1,
tags: [ 'Originelle Idee', 'Drink', 'Vegan' ] },
{ name: 'Bananen Shake',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '1 Banane', '200 g Magerquark', '1 TL Honig', '400 ml Wasser' ],
preparation:
 [ 'Banane schälen, klein schneiden.',
   'Honig, Magerquark und Wasser in ein hohes Gefäß geben und mit einem Stabmixer&nbsp;pürieren.' ],
portions: 1,
tags: [ 'Der Klassiker', 'Snacks', 'Drink' ] },
{ name: 'Honig Beeren Shake',
prev: 'honig_beeren.jpg',
time: '5 min.',
ingredients:
 [ '250 g Magerquark',
   '200 g gefrorene Beeren (z.B. Heidelbeeren)',
   '200 ml Wasser',
   '1 TL Honig' ],
preparation:
 [ 'Alle Zutaten in ein hohes Gefäß geben und fein pürieren.',
   'Falls frische Beeren gewählt werden, ein wenig Crushed Eis dazu geben.' ],
portions: 1,
tags: [ 'Fruchtig', 'Snacks', 'Drink' ] },
{ name: 'Apfel Kiwi Shake',
prev: 'apfel_kiwi_smoothie.jpg',
time: '5 min.',
ingredients:
 [ '1 Apfel',
   '1 reife Kiwi',
   '4 EL Naturjoghurt',
   '3 EL Magerquark',
   '2-3 Eiswürfel',
   '250 ml stilles Wasser' ],
preparation:
 [ 'Apfel und Kiwi schälen. Apfel entkernen. Obst kleinschneiden.',
   'Alle Zutaten in ein hohes Gefäß geben. Mit einem Pürierstab pürieren.' ],
portions: 1,
tags: [ 'Superschnell', 'Snacks', 'Drink' ] },
{ name: 'Pfirsich Bananen Shake',
prev: 'pfirsich_bananen.jpg',
time: '10 min.',
ingredients:
 [ '1 reife Pfirsich',
   '1 reife Banane',
   '1 TL Honig',
   '5 EL Magerquark',
   '300 ml stilles kaltes Wasser' ],
preparation:
 [ 'Pfirsich waschen. Banane und Pfirsich schälen. Obst in feine Stücke schneiden.',
   'Alle Zutaten in ein hohes Gefäß geben und mit einem Stabmixer feinpürieren.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Kiwi Zitronen Shake ',
prev: 'kiwi_zitronen_shake.jpg',
time: '10 min.',
ingredients:
 [ '2 Kiwis',
   '3 Ananasscheiben',
   '½ Zitrone',
   '1 TL Honig',
   '150 g Magerquark',
   '2 TL Crushed Eis' ],
preparation:
 [ 'Kiwis schälen, in kleine Stücke schneiden. Ananasscheiben in kleine Stücke schneiden. Zitrone auspressen.',
   'Zitronensaft mit Honig vermengen.',
   'Alle Zutaten in einen hohen Behälter geben und pürieren.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Schoko Kokos Shake',
prev: 'schoko_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 ml Kokosmilch',
   '1 TL Kakaopulver (ungezuckert)',
   '100 ml fettarme Milch',
   '1 EL Crushed Ice',
   '1 TL Kokosraspeln' ],
preparation:
 [ 'Kakaopulver mit Kokosmilch, Milch und Eis in einen verschließbaren Behälter geben (z.B. Shaker). Kräftig durchschütteln.',
   'Nach Belieben mit Kokosraspeln bestreuen.' ],
portions: 1,
tags: [ 'Fruchtig-süß', 'Snacks', 'Drink' ] },
{ name: 'Power Booster Shake',
prev: 'starter_shake.png',
time: '5 min.',
ingredients:
 [ '40 g Haferflocken',
   '20 g gepopptes Amaranth',
   '100 g Beeren z.B. Blaubeeren',
   '400 ml Hafermilch',
   '1 EL Leinsamen',
   '30 g Walnusskerne',
   '1 EL Agavendicksaft',
   '4 Eiswürfel',
   '1 TL Matcha Pulver' ],
preparation:
 [ 'Walnusskerne kleinhacken.',
   'Alle Zutaten in einen Mixer geben und mixen.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Knusper Pancakes mit Himbeer-Creme',
prev: 'pancake.jpg',
time: '20 min.',
ingredients:
 [ '60 g Vollkornmehl',
   '10 g Agavendicksaft',
   '140 ml Sojamilch',
   '1 EL Olivenöl',
   '1 TL Backpulver',
   '30 g gepopptes Amaranth',
   '150 g Himbeeren (gefroren)',
   '30 g Agavendicksaft',
   '100 g Sojajoghurt Natur' ],
preparation:
 [ 'Das Vollkornmehl, 10 g Agavendicksaft, Sojamilch, Backpulver und etwas Salz mit einem Schneebeesen zu einem Teig verrühren. Das Amaranth anschließend unterheben.',
   'Olivenöl in einer Pfanne erhitzen. Mit einem Esslöffel Teig in die Pfanne geben und nach und nach ca. 6 kleine Pancakes formen. Bei mittlerer Hitze von beiden Seiten ca. 4 Minuten anbraten.',
   'Himbeeren, 30g Agavendicksaft und den Sojajoghurt in einen Mixer geben und fein pürieren.',
   'Himbeercreme zu den Pancakes servieren.' ],
portions: 2,
tags:
 [ 'Ballaststoffreiche Alternative',
   'Breakfast',
   'Snacks',
   'Vegan' ] },
{ name: 'Kokos Cranberry Müsli',
prev: 'cranberry_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 g Haferflocken',
   '50 g Kokosmilch',
   '30 g Agavendicksaft',
   '40 g Cranberrys',
   '160 g Sojajoghurt',
   '2 Scheiben Ananas',
   '30 g Kokosraspeln' ],
preparation:
 [ 'Haferflocken mit Kokosmilch, Agavendicksaft, Cranberrys und dem Sojajoghurt in einer Schüssel miteinander vermengen. 4 Minuten ziehen lassen.',
   'Ananasscheiben in kleine Stücke schneiden.',
   'Ananasstücke und Kokosraspeln mit dem restlichen Müsli vermengen.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Süßkartoffelsalat',
prev: 'suesskartoffelsalat.jpg',
time: '30 min.',
ingredients:
 [ '1 große Süßkartoffel',
   '100 g gemischte Sprossen (z.B. Radieschensprossen)',
   '1/2 Zitrone',
   '2 EL Weißweinessig',
   '1/2 TL scharfer Senf',
   '1 TL Meerrettich',
   '3 EL Olivenöl',
   '1/2 Bund Koriander',
   '2 Stangen Frühlingszwiebeln',
   ',Salz, Pfeffer',
   ',&nbsp;' ],
preparation:
 [ 'Süßkartoffel waschen und in gesalzenem Wasser weich&nbsp;kochen. Abschütten, schälen&nbsp;und in kleine Stücke schneiden.',
   'In der Zwischenzeit Sprossen waschen. Zitrone waschen und auspressen. Saft der Zitrone mit Essig, Senf, Meerrettich, Salz und Pfeffer verrühren. Nach und nach Olivenöl unterrühren.',
   'Koriander waschen, trocken tupfen, Blätter abzupfen. Frühlingszwiebeln waschen und&nbsp;in feine Ringe schneiden.',
   'Süßkartoffelstücke, Koriander, Frühlingszwiebeln und Sprossen in eine Schüssel geben. Mit Salz und Pfeffer abschmecken. Marinade über den Salat geben und servieren.' ],
portions: 2,
tags: [ 'Sättigend', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Rote Beete Suppe mit Meerrettich ',
prev: 'rote_beete_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 Zwiebel',
   '1 Süßkartoffel',
   '400 g rote Beete',
   '1 EL Olivenöl',
   '800 ml gesalzenes Wasser (oder Gemüsebrühe)',
   '1 EL Weißweinessig',
   ',gemahlener Kümmel',
   '1 EL Meerrettich',
   '100 ml Sojasahne',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Zwiebel schälen und in feine Stücke hacken. Kartoffel und rote Beete waschen, schälen und in feine Stücke schneiden.',
   'Olivenöl in einer Pfanne erhitzen. Zwiebel darin kurz andünsten. Kartoffeln und rote Beete dazugeben und kurz mitbraten. Mit gesalzenem Wasser ablöschen. Mit Salz, Pfeffer, Essig und Kümmel würzen. Zugedeckt 20 Minuten köcheln lassen.',
   'Meerrettich dazugeben und die Suppe anschließend mit einem Stamixer pürieren. 100 ml Sojasahne unterrühren.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Rührei aus Tofu',
prev: 'tofu_ruehrei.png',
time: '15 min.',
ingredients:
 [ '200 g weicher Naturtofu',
   '1 EL Olivenöl',
   '1 EL Wasser',
   '2 Cherrytomaten',
   '1 Stange Frühlingszwiebel',
   '1/2 Tl Kurkuma',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Tofu mit einer Gabel zerbröseln. Tomaten, Frühlingszwiebel waschen. Tomaten halbieren. Frühlingszwiebel in feine Ringe schneiden.',
   'Tofu rund 3 Minuten anbraten. Tomaten und Frühlingszwiebel dazugeben und kurz anbraten. Mit Kurkuma, Salz und Pfeffer würzen.' ],
portions: 1,
tags:
 [ 'Vegane Alternative',
   'Breakfast',
   'Dinner',
   'Snacks',
   'Vegan' ] },
{ name: 'Knuspriges Mandelmüsli',
prev: 'mandelmuesli.png',
time: '10 min.',
ingredients:
 [ '20 g Amaranth gepoppt',
   '25 g Cornflakes (ungesüßt)',
   '40 g Haferflocken',
   '15 g geröstete Mandeln',
   '20 g Blaubeeren',
   '15 g Mandeln',
   '20 g Cranberrys',
   '1 EL Leinsamen',
   ',Obst nach Wahl z.B. 1 Banane',
   '200 ml Mandelmilch' ],
preparation:
 [ 'Amaranth, Cornflakes, Haferflocken, geröstete Mandeln und Mandeln in einer Schüssel miteinander vermengen.',
   'Beeren waschen. Banane schälen und in mundgerechte Stücke schneiden. Obst in die Schüssel geben und mit den anderen Zutaten vermengen.',
   'Knuspermüsli mit Mandelmilch übergießen.' ],
portions: 1,
tags:
 [ 'Mit Amaranth', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Frikadellen mit Süßkartoffelpüree',
prev: 'frikadellen_mit_suesskartoffel.jpg',
time: '30 min.',
ingredients:
 [ '400 g Möhren',
   '1 Süßkartoffel',
   '300 g fettarmes Rinder-Hackfleisch',
   '2 EL Magerquark',
   '2 TL Vollkorn-Semmelbrösel',
   '1 EL Olivenöl',
   '3 EL gehackte Kräuter',
   '3-4 EL fettarme Milch',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Möhren und Süßkartoffel waschen, schälen und in kleine Stücke schneiden. In einen mit Salzwasser gefüllten Kochtopf geben und rund 15 Minuten gar kochen.',
   'In der Zwischenzeit das Hackleisch, den Magerquark, die Vollkorn-Semmelbrösel, Kräuter, Salt und Pfeffer miteinander verkneten. 4 Frikadellen daraus formen.',
   'Olivenöl in einer Pfanne erhitzen. Frikadellen bei mittlerer Hitze braun braten.',
   'Möhren und Kartoffel abgießen. Fettarme Milch dazugeben und fein zerstampfen. Mit Salz und Pfeffer würzen. Zu den Frikadellen servieren.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch' ] },
{ name: 'Rote Beete Tower mit Avocadocreme',
prev: 'rote_beete_tower.jpg',
time: '20 min.',
ingredients:
 [ '250 g Rote Beete',
   '300 g Naturtofu',
   '3 EL Olivenöl',
   '2 TL Agavendicksaft',
   '1 Knoblauchzehe',
   '3 Avocados',
   '1 EL Zitronensaft',
   ',etwas Kresse',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Rote Beete waschen, in feine Scheiben schneiden. Topf mit Salzwasser erhitzen und rund 10 Minuten garen bis sie weich sind.',
   'Tofu in 5 mm dicke Scheiben schneiden und anschließend mit einem kleinen Glas Kreise in der Größe der Roten Beete ausstechen.',
   'Olivenöl in einer Pfanne erhitzen und den Tofu von jeder Seite rund 3 Minuten anbraten. Mit Salz und Pfeffer würzen.',
   'Knoblauch schälen, feinhacken. Avocados waschen, halbieren und entkernen. Avocadofleisch mit Knoblauch und Zitronensaft pürieren. Mit Salz und Pfeffer würzen.',
   'Tofuscheiben mit roter Beete und Avocadocreme abwechselnd schichten. Mit Kresse bestreuen und servieren.' ],
portions: 2,
tags:
 [ 'Originelle Idee', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Kohlrabi Ravioli mit Tomaten Basilikum Soße',
prev: 'kohlrabi_ravioli.jpg',
time: '30 min.',
ingredients:
 [ '2 Kohlrabi',
   '6 EL Olivenöl',
   '1 rote Paprika',
   '1 1/2 Zwiebeln',
   '2 Tomaten',
   '1/2 Bund Basilikum',
   '2 Knoblauchzehen',
   ',Salz, Pfeffer, Oregano' ],
preparation:
 [ 'Kohlrabi waschen, schälen und in sehr feine Scheiben hobeln oder schneiden. Gesalzenes Wasser in einem Topf aufkochen, vom Herd nehmen und die feinen Kohlrabischeiben rund 10 Minuten gar ziehen lassen. Mit einem Küchenpapier gut abtropfen. 2 EL Olivenöl und 1 Prise Salz in einer kleinen Schüssel mischen, Kohlrabischeiben hineinlegen und marinieren.',
   'Paprika waschen, entkernen, in feine Stücke schneiden. Zwiebeln schälen, fein hacken. 1 EL Olivenöl in einer Pfanne erhitzen und etwa 1/3 der Zwiebel und Paprika Stücke rund 5 Minuten anbraten. Pfanne vom Herd nehmen und angebratene Tomaten-Zwiebelmasse mit einer Gabel zerdrücken. Mit Oregano, Salz und Pfeffer würzen. Pfanne wieder auf die Herdplatte legen und kurz erhitzen bis die Masse cremig ist.',
   'In die Mitte der marinierten Kohlrabischeiben 1 TL der Paprika-Zwiebel-Masse geben. Eine zweite Kohlrabischeibe darauflegen und etwas an der Seite andrücken.',
   'Tomaten waschen und klein würfeln. Knoblauchzehen schälen, feinhacken.Olivenöl in einer Pfanne erhitzen. Die restlichen Zwiebeln und den Knoblauch rund 2 Minuten andünsten. Tomaten dazu geben und kurz mitgaren. Basilikum unterheben. Mit Salz und Pfeffer würzen.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Schoko Erdnuß Eis',
prev: 'schoko_erdnuss_eis.jpg',
time: '25 min.',
ingredients:
 [ '200 g Erdnußmus',
   '250 g Eiswürfel',
   '65g Agavendicksaft',
   '1/2 TL gemahlene Vanille',
   ',Salz',
   '40 g Kakao' ],
preparation:
 [ 'Erdnußmus, Agavendicksaft, Eiswürfel, Salz und Vanille in einem Mixer mischen.',
   'Die Hälfte der Masse mit Kakao vermengen. Beide Massen mit einer Gabel nochmals feinrühren.',
   'Eis in einer Schüssel in einem Kühlschrank rund 20 Minuten kaltstellen.' ],
portions: 1,
tags: [ 'Erfrischend', 'Snacks', 'Vegan' ] },
{ name: 'Eier mit Senfsauce',
prev: 'eier_senf.jpg',
time: '25 min.',
ingredients:
 [ '4 Eier',
   '1 kleine Zwiebel',
   '50 ml fettarme Milch',
   '2 TL Dill',
   '2 EL Hüttenkäse',
   '2 EL fettarmer Joghurt',
   '3 TL Senf',
   '1 TL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Eier rund 10 Minuten hart kochen.',
   'Zwiebel schälen, feinhacken.',
   'Olivenöl in einer Pfanne erhitzen. Zwiebelwürfel kurz andünsten bis sie glasig sind.',
   'Mit Milch ablöschen. Hüttenkäse, Joghurt und Senf einrühren. Kurz aufkochen lassen.',
   'Hartgekochte Eier schälen, halbieren und mit Sauce anrichten.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Petersilienwurzelsuppe',
prev: 'petersiliensuppe.jpg',
time: '30 min.',
ingredients:
 [ '200g Petersilienwurzel',
   '½ rote Zwiebel',
   '1 Knoblauchzehe',
   '200g Hüttenkäse',
   '½ Bund Petersilie',
   '250 ml Wasser',
   '1EL Olivenöl',
   ',Salz, Pfeffer' ],
preparation:
 [ 'Petersilienwurzel waschen, längs&nbsp;halbieren und&nbsp;in Scheiben schneiden.',
   'Zwiebel und Knoblauch schälen, fein würfeln.',
   'Olivenöl in einem Topf erhitzen. Petersilienwurzel-, Zwiebel- und Knoblauchwürfel in den Topf geben und rund 5 Minuten anbraten.',
   'Wasser hinzugeben und rund 20 Minuten köcheln lassen.',
   'Währenddessen Petersilie waschen, trocknen und fein hacken. Suppe nach Ende der Kochzeit mit einem Stabmixer pürieren. Hüttenkäse untermischen und mit Petersilie bestreuen.' ],
portions: 1,
tags: [ 'Aromatisch', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Möhren Gurken Smoothie',
prev: 'moere_gurken_smothie.jpg',
time: '5 min.',
ingredients:
 [ '1 Salatgurke',
   '300ml Möhrensaft (ungesüßt)',
   '50g Haferflocken',
   '200g Magerquark',
   '100ml Wasser' ],
preparation:
 [ 'Gurke waschen, grob in Stücke schneiden.',
   'Alle Zutaten in einem Mixer geben und fein pürieren bis ein cremiger Shake entsteht.' ],
portions: 1,
tags: [ 'Mahlzeitersatz', 'Drink' ] } ]


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts/at.js